const DocumentIcon = ({ className }: { className: string }) => (
  <svg
    aria-hidden='true'
    width='71'
    height='70'
    viewBox='0 0 71 70'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M42.8734 6.5625L42.2872 22.4266L54.9574 22.8929L42.8734 6.5625ZM15.5391 7.67514L16.857 63.4375L55.5205 62.5253V62.5177L54.6577 26.0188L39.2941 26.3811L38.8392 7.12562L15.5391 7.67514Z'
      fill='#FF620F'
    />
  </svg>
);

export default DocumentIcon;
